import type { Density, Theme } from '../theme';
import { ShellLayout, type NavItem } from './ShellLayout';
import { VendorPortalOverview } from './VendorPortalOverview';

/**
 * Vendor self-service portal (FR-1/FR-22/UX-DR9). Shows NO customer identities;
 * full declare/upload surfaces arrive in Epic 5.
 */
export function PortalShell({
  theme,
  density,
  onToggleTheme,
  onToggleDensity,
}: {
  theme: Theme;
  density: Density;
  onToggleTheme: () => void;
  onToggleDensity: () => void;
}): React.JSX.Element {
  // No count badges: the two badge-able sections are placeholders until Epic 5, so this shell
  // holds no totals at all — and a badge on a "arrives in a later epic" placeholder would be
  // a number about nothing.
  const nav: NavItem[] = [
    {
      label: 'Overview',
      icon: 'layout',
      content: <VendorPortalOverview />,
    },
    { label: 'My Certificates', icon: 'award' },
    { label: 'Profile', icon: 'user' },
  ];

  return (
    <ShellLayout
      roleLabel="Vendor Portal"
      navItems={nav}
      theme={theme}
      density={density}
      onToggleTheme={onToggleTheme}
      onToggleDensity={onToggleDensity}
    />
  );
}
